/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Dutch (Netherlands)
export default {
  'ai-summary-label': 'Samenvatten',
  'copy-content-link-label': 'Link kopiëren',
  'dynamic-cards-search-page.advanced-search.labels.filter.no.text': 'Begin met typen om naar een label te zoeken',
  'dynamic-cards-search-page.app-filter-sidebar.all': 'Alle',
  'dynamic-cards-search-page.app-filter-sidebar.group': 'Zoekopdracht filteren op product',
  'dynamic-cards-search-page.atlas.for': 'voor',
  'dynamic-cards-search-page.avatar': 'Avatar',
  'dynamic-cards-search-page.calendar-event-search-result.calendar-label': 'Kalender',
  'dynamic-cards-search-page.calendar-event-search-result.join-meeting-link': 'Deelnemen aan vergadering',
  'dynamic-cards-search-page.calendar-event-search-result.meeting-link': 'Vergaderlink',
  'dynamic-cards-search-page.calendar-event-search-result.meeting-link-icon': 'Deelnemen aan vergadering',
  'dynamic-cards-search-page.calendar-event-search-result.past-events-button': 'Oude gebeurtenissen',
  'dynamic-cards-search-page.calendar-event-search-result.recurring-event-icon': 'Terugkerende gebeurtenis',
  'dynamic-cards-search-page.calendar-event-search-result.recurring-event-label': 'Terugkerend',
  'dynamic-cards-search-page.calendar-event-search-result.upcoming-events-button': 'Aankomende evenementen',
  'dynamic-cards-search-page.compass.owner-name': 'Eigendom van {ownerName}',
  'dynamic-cards-search-page.compass.state': '{state}',
  'dynamic-cards-search-page.compass.tier': 'Niveau {tier}',
  'dynamic-cards-search-page.confluence.filter.content.placeholder': 'Zoek inhoud',
  'dynamic-cards-search-page.confluence.filter.content.selected': 'Geselecteerd',
  'dynamic-cards-search-page.confluence.filter.content.unselected': 'Suggesties',
  'dynamic-cards-search-page.confluence.filter.contributor.label.selected': 'Geselecteerd',
  'dynamic-cards-search-page.confluence.filter.contributor.label.unselected': 'Suggesties',
  'dynamic-cards-search-page.confluence.filter.contributor.placeholder': 'Zoek personen',
  'dynamic-cards-search-page.confluence.filter.label.selected': 'Geselecteerd',
  'dynamic-cards-search-page.confluence.filter.labels.placeholder': 'Label zoeken',
  'dynamic-cards-search-page.confluence.filter.space.placeholder': 'Spaces zoeken',
  'dynamic-cards-search-page.connect_third_party_product_description':
    'Koppel je account om ontbrekende resultaten te zien',
  'dynamic-cards-search-page.connect_third_party_product_title': 'Je beheerder heeft {product} toegevoegd!',
  'dynamic-cards-search-page.connect_third_party_product_title_alternate': '{product} is nu beschikbaar!',
  'dynamic-cards-search-page.date.filter.custom.invalid.after.end': 'De begindatum moet eerder zijn dan de einddatum',
  'dynamic-cards-search-page.date.filter.custom.invalid.after.today': 'De begindatum kan niet in de toekomst liggen',
  'dynamic-cards-search-page.date.filter.custom.invalid.to.after.today': 'De einddatum kan niet in de toekomst liggen',
  'dynamic-cards-search-page.date.filter.last.month': 'Afgelopen 30 dagen',
  'dynamic-cards-search-page.date.filter.last.week': 'Afgelopen 7 dagen',
  'dynamic-cards-search-page.date.filter.last.year': 'Afgelopen jaar',
  'dynamic-cards-search-page.document-search-result.google-slides-label': 'Slides',
  'dynamic-cards-search-page.document-search-result.ms-excel-label': 'Excel',
  'dynamic-cards-search-page.document-search-result.ms-powerpoint-label': 'PowerPoint',
  'dynamic-cards-search-page.document-search-result.ms-word-label': 'Word',
  'dynamic-cards-search-page.dropdown_generate_answer': 'Antwoord genereren',
  'dynamic-cards-search-page.dropdown_recent_icon_label': 'Recent',
  'dynamic-cards-search-page.error_primary': 'Het lukt ons niet om te zoeken.',
  'dynamic-cards-search-page.error_secondary':
    'Dit is mogelijk gewoon een foutje. Het beste kun je het <btn>opnieuw proberen</btn>.',
  'dynamic-cards-search-page.externalPeopleLabel': 'Externe mensen #{channelName}',
  'dynamic-cards-search-page.externalPersonLabel': 'Extern persoon',
  'dynamic-cards-search-page.filter.clear.filter.label': 'Filter wissen',
  'dynamic-cards-search-page.filter.last.updated.anytime': 'Willekeurig',
  'dynamic-cards-search-page.filter.last.updated.past30Days': 'Afgelopen 30 dagen',
  'dynamic-cards-search-page.filter.last.updated.past7Days': 'Afgelopen 7 dagen',
  'dynamic-cards-search-page.filter.last.updated.pastYear': 'Afgelopen jaar',
  'dynamic-cards-search-page.filter.last.updated.today': 'Vandaag',
  'dynamic-cards-search-page.filter.last.updated.yesterday': 'Gisteren',
  'dynamic-cards-search-page.filter.type.answer': 'Antwoorden',
  'dynamic-cards-search-page.filter.type.attachment': 'Bijlagen',
  'dynamic-cards-search-page.filter.type.blogpost': 'Blogposts',
  'dynamic-cards-search-page.filter.type.branch': 'Branches',
  'dynamic-cards-search-page.filter.type.calendar': 'Kalenders',
  'dynamic-cards-search-page.filter.type.comment': 'Opmerkingen',
  'dynamic-cards-search-page.filter.type.commit': 'Commits',
  'dynamic-cards-search-page.filter.type.component': 'Componenten',
  'dynamic-cards-search-page.filter.type.conversation': 'Gesprekken',
  'dynamic-cards-search-page.filter.type.database': 'Databases',
  'dynamic-cards-search-page.filter.type.design': 'Ontwerpen',
  'dynamic-cards-search-page.filter.type.documents': 'Documenten',
  'dynamic-cards-search-page.filter.type.issue': 'Issues',
  'dynamic-cards-search-page.filter.type.message': 'Berichten',
  'dynamic-cards-search-page.filter.type.page': "Pagina's",
  'dynamic-cards-search-page.filter.type.placeholder': 'Zoek naar het type',
  'dynamic-cards-search-page.filter.type.presentation': 'Presentaties',
  'dynamic-cards-search-page.filter.type.pull-request': 'Pull requests',
  'dynamic-cards-search-page.filter.type.question': 'Vragen',
  'dynamic-cards-search-page.filter.type.repository': "Repository's",
  'dynamic-cards-search-page.filter.type.space': 'Spaces',
  'dynamic-cards-search-page.filter.type.space-calendar': 'Spacekalenders',
  'dynamic-cards-search-page.filter.type.spreadsheet': 'Spreadsheets',
  'dynamic-cards-search-page.filter.type.video': "Video's",
  'dynamic-cards-search-page.filter.type.web-page': "Webpagina's",
  'dynamic-cards-search-page.filter.type.whiteboard': 'Whiteboards',
  'dynamic-cards-search-page.filters.dropdown.clear-all': 'Alles wissen',
  'dynamic-cards-search-page.filters.dropdown.title': 'Filter',
  'dynamic-cards-search-page.filters.names.content': 'Inhoud onder',
  'dynamic-cards-search-page.filters.names.contributor': 'Bijdrager',
  'dynamic-cards-search-page.filters.names.labels': 'Label',
  'dynamic-cards-search-page.filters.names.titleMatchOnly': 'Titel overeenkomst',
  'dynamic-cards-search-page.github-branch-result.label': 'Branch',
  'dynamic-cards-search-page.github-commit-result.label': 'Commit',
  'dynamic-cards-search-page.github-pull-request-result.label': 'Pull request',
  'dynamic-cards-search-page.input_placeholder_search_only': 'Zoek wat je maar wilt',
  'dynamic-cards-search-page.jira.filter.project.placeholder': 'Projecten zoeken',
  'dynamic-cards-search-page.landing_primary': 'Ga aan de slag met filters voor dynamische kaarten',
  'dynamic-cards-search-page.legacy-third-party-result.google-docs-label': 'Docs',
  'dynamic-cards-search-page.legacy-third-party-result.google-sheets-label': 'Sheets',
  'dynamic-cards-search-page.legacy-third-party-result.ms-excel-label': 'Excel',
  'dynamic-cards-search-page.legacy-third-party-result.ms-powerpoint-label': 'PowerPoint',
  'dynamic-cards-search-page.legacy-third-party-result.ms-word-label': 'Word',
  'dynamic-cards-search-page.legacy-third-party-result.slack-label': 'Slack',
  'dynamic-cards-search-page.no_results_primary': 'We hebben geen resultaten gevonden die aan je zoekopdracht voldoen',
  'dynamic-cards-search-page.no_results_secondary_some_filters_applied':
    'Het lijkt erop dat je een aantal filters hebt toegepast. Je kunt de filters wissen.',
  'dynamic-cards-search-page.nouns.goal': 'Doel',
  'dynamic-cards-search-page.nouns.goals': 'Doelen',
  'dynamic-cards-search-page.nouns.tag': 'Tag',
  'dynamic-cards-search-page.nouns.tags': 'Tags',
  'dynamic-cards-search-page.number_of_results':
    'Er worden {numberOfResults,number} van de {totalCount,number} resultaten weergegeven',
  'dynamic-cards-search-page.oauth-banner.authorization-fail': 'De autorisatie voor {product} is mislukt.',
  'dynamic-cards-search-page.oauth-banner.authorization-success': 'De autorisatie voor {product} is gelukt.',
  'dynamic-cards-search-page.oauth-message-connect': 'Koppelen',
  'dynamic-cards-search-page.products.custom-website': 'Webpagina',
  'dynamic-cards-search-page.results-sort.createdDate.selected': 'Sorteren op aangemaakt (nieuwste)',
  'dynamic-cards-search-page.results-sort.createdDateDESC': 'Aangemaakt (nieuwste)',
  'dynamic-cards-search-page.results-sort.latestModifiedDateDESC': 'Bijgewerkt (nieuwste)',
  'dynamic-cards-search-page.results-sort.latestModifiedDateDESC.selected': 'Sorteren op bijgewerkt (nieuwste)',
  'dynamic-cards-search-page.results-sort.sort-options.label': 'Sortering van lijst wijzigen',
  'dynamic-cards-search-page.rovo-onboarding-next': 'Volgende',
  'dynamic-cards-search-page.rovo-onboarding-step-1-description':
    'Filter op product om relevantere zoekresultaten te zien.',
  'dynamic-cards-search-page.rovo-onboarding-step-1-heading': 'Zoeken in alle workspaces van je bedrijf',
  'dynamic-cards-search-page.rovo-onboarding-step-1-progress': '1/2',
  'dynamic-cards-search-page.rovo-onboarding-step-2-description':
    'Afhankelijk van het product waarop je filtert, veranderen deze opties om specifieke resultaten te verkrijgen.',
  'dynamic-cards-search-page.rovo-onboarding-step-2-heading': 'Precies vinden waar je naar zoekt',
  'dynamic-cards-search-page.rovo-onboarding-step-2-progress': '2/2',
  'dynamic-cards-search-page.search-result.attachment-label': 'Bijlage',
  'dynamic-cards-search-page.search-result.attachments.attached-date.label': 'Bijgevoegd {formattedDate}',
  'dynamic-cards-search-page.search-result.attachments.audio-label': 'Audio',
  'dynamic-cards-search-page.search-result.attachments.image-label': 'Afbeelding',
  'dynamic-cards-search-page.search-result.attachments.pdf-label': 'PDF',
  'dynamic-cards-search-page.search-result.last-modified': 'Bijgewerkt: {formattedDate}',
  'dynamic-cards-search-page.search-result.private-channel-label': 'Privékanaal',
  'dynamic-cards-search-page.search-result.remove-recent-search': 'Pictogram voor recente zoekopdrachten verwijderen',
  'dynamic-cards-search-page.search-result.repository-label': 'Repository',
  'dynamic-cards-search-page.search-result.thread-title-wth-others':
    '{contributorCount, plural, =0 {Groepsbericht met externe gebruikers} =2 {{name1} en {name2}} =3 {{name1}, {name2} en {name3}} =4 {{name1}, {name2}, {name3} en {overflowContributorCount} anderen} one {{name1}} other {{name1}, {name2}, {name3} en {overflowContributorCount} anderen}}',
  'dynamic-cards-search-page.search-result.unknown-channel-in-thread': 'onbekend-kanaal',
  'dynamic-cards-search-page.search_result_type_answer': 'Antwoord',
  'dynamic-cards-search-page.search_result_type_card': 'Kaart',
  'dynamic-cards-search-page.search_result_type_component': 'Component',
  'dynamic-cards-search-page.search_result_type_document': 'Document',
  'dynamic-cards-search-page.search_result_type_embed': 'Smart Link',
  'dynamic-cards-search-page.search_result_type_folder': 'Map',
  'dynamic-cards-search-page.search_result_type_presentation': 'Presentatie',
  'dynamic-cards-search-page.search_result_type_pull_request': 'Pull request',
  'dynamic-cards-search-page.search_result_type_sharepoint_document': 'SharePoint-document',
  'dynamic-cards-search-page.search_result_type_space_calendar': 'Spacekalender',
  'dynamic-cards-search-page.search_result_type_spreadsheet': 'Spreadsheet',
  'dynamic-cards-search-page.search_result_type_unrecognised': 'Niet herkend',
  'dynamic-cards-search-page.search_result_type_work_item': 'Werkitem',
  'dynamic-cards-search-page.sidebar-authorize_connect_third_party_product':
    'Je beheerder heeft <strong>{product}</strong> toegevoegd!{br} Koppel je account om ontbrekende resultaten te bekijken, inclusief documenten waar alleen jij toegang toe hebt.',
  'dynamic-cards-search-page.sidebar-authorize_connect_third_party_product_alternate':
    '<strong>{product} is nu beschikbaar!</strong>{br} Koppel je account om ontbrekende resultaten te bekijken, inclusief documenten waar alleen jij toegang toe hebt.',
  'dynamic-cards-search-page.sidebar-oauth-warning-authorize': 'Autoriseren',
  'dynamic-cards-search-page.sidebar-oauth-warning.authorization-fail': 'De autorisatie voor {product} is mislukt.',
  'dynamic-cards-search-page.sidebar-oauth-warning.authorization-success': 'De autorisatie voor {product} is gelukt.',
  'dynamic-cards-search-page.tab-filter.all-filter-visual-label': 'Filteren op alle apps',
  'dynamic-cards-search-page.tab-filter.more-dropdown-label': 'Filteren op meer apps',
  'dynamic-cards-search-page.townsquare.api.goal-state.archived': 'Gearchiveerd',
  'dynamic-cards-search-page.townsquare.api.goal-state.at-risk': 'Loopt gevaar',
  'dynamic-cards-search-page.townsquare.api.goal-state.cancelled': 'Geannuleerd',
  'dynamic-cards-search-page.townsquare.api.goal-state.completed': 'Voltooid',
  'dynamic-cards-search-page.townsquare.api.goal-state.off-track': 'Niet op schema',
  'dynamic-cards-search-page.townsquare.api.goal-state.on-track': 'Op schema',
  'dynamic-cards-search-page.townsquare.api.goal-state.paused': 'Onderbroken',
  'dynamic-cards-search-page.townsquare.api.goal-state.pending': 'In behandeling',
  'dynamic-cards-search-page.video-search-result.dropdown-message':
    '{chapterCount, plural, one {{chapterCount,number} hoofdstuk in deze video} other {{chapterCount,number} hoofdstukken in deze video}}',
  'dynamic-cards-search-page.video-search-result.video-icon-label': 'pictogram video',
  'dynamic-cards-search-page.video-search-result.video-thumbnail-alt-text': 'Videominiatuur',
  'dynamic-cards-search-page.work-item-assignee.assigned': 'is toegewezen',
  'dynamic-cards-search-page.work-item-creator.created': 'maakte',
  'dynamic-cards-search-page.work-item-status.for': 'voor',
  'dynamic-cards-search-page.work-item-ticket.label': 'Ticket',
  'dynamic-cards-search-page.work-item.label': 'Werkitem',
  'initialsAvatar.label': 'Avatar met initialen',
  'personAvatar.label': 'Avatar met persoon',
  'search-page.results.private-result-label': 'Privé',
  'search-page.results.private-result-tooltip': 'Alleen zichtbaar voor jou',
  'search-page.results.product-results.third-party.channel-member-count':
    '{memberCount, plural, one {{memberCount,number} lid} other {{memberCount,number} leden}}',
  'search-page.results.product-results.third-party.channel-type-label': 'Kanaal',
  'search-page.results.product-results.third-party.conversation-search-result.label': 'Kanaal',
  'search-page.results.product-results.third-party.conversation-search-result.member-count':
    '{count, plural, one {{count,number} lid} other {{count,number} leden}}',
  'search-page.results.product-results.third-party.conversation-search-result.time-since-label':
    'Laatst actief op {formattedDate}',
  'search-page.results.product-results.third-party.conversation-search-result.unknown-channel': 'onbekend-kanaal',
  'search-page.results.product-results.third-party.external-people-label': 'Externe personen',
  'search-page.results.product-results.third-party.external-person-label': 'Externe persoon',
  'search-page.results.product-results.third-party.last-active': 'Laatst actief op {relativeDate}',
  'search-page.results.product-results.third-party.message-type-label': 'Bericht',
  'search-page.results.product-results.third-party.no-contributors-label': 'Externe personen in #{channelName}',
  'search-page.results.product-results.third-party.private-conversation-text': '{users} in een privégesprek',
  'search-page.results.product-results.third-party.thread-type-label': 'Thread',
  'search-page.results.product-results.third-party.title-and-channel-name': '{title} in #{channelName}',
  'search-page.results.product-results.third-party.title-with-remaining-contributors':
    '{remainingContributorsCount, plural, one {{title} en {remainingContributorsCount} iemand anders} other {{title} en {remainingContributorsCount} anderen}}',
  'search-page.results.restricted-result-label': 'Beperkt',
  'search-page.results.restricted-result-tooltip': 'Alleen zichtbaar voor specifieke personen',
  'search-page.show-more-breadcrumbs-button-label': 'Meer breadcrumbs tonen',
  'search-page.verified-icon-label': 'Geverifieerd',
  'search-page.verified-icon-tooltip-message': 'Deze pagina is geverifieerd door een eigenaar of beheerder.',
  'search-result.result.count':
    '{count, plural, one {{count} resultaat wordt weergegeven} other {{count} resultaten worden weergegeven}}',
  'search-result.user-mention.external-person': 'Extern persoon',
};
